module.exports = __webpack_public_path__ + "static/media/be.57160833.svg";